import { Observable } from '../../Observable';
import { mergeAll } from '../../operator/mergeAll';
Observable.prototype.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map